import { callApi } from './config/callApi'

export const bottles = async (method: string, path?: string, data: any | null = null): Promise<any> => {
  const url = `/bottles${path}`

  return callApi({
    method,
    url,
    data,
  })
}
